import React from 'react'

import { Holiday2018 } from '../../../config/images'

const Holiday2018Array = [
	{ path: '48234037_2308766715865173_8982457301063434240_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48234037_2308766715865173_8982457301063434240_o.jpg', w: 1000, h: 668 },
	{ path: '48239702_2308779505863894_1001542508926205952_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48239702_2308779505863894_1001542508926205952_o.jpg', w: 1000, h: 668 },
	{ path: '48243218_2308762975865547_4372329157468618752_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48243218_2308762975865547_4372329157468618752_o.jpg', w: 1000, h: 668 },
	{ path: '48254005_2309077972500714_5492815897984761856_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48254005_2309077972500714_5492815897984761856_o.jpg', w: 1000, h: 668 },
	{ path: '48266322_2308771595864685_255738768168845312_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48266322_2308771595864685_255738768168845312_o.jpg', w: 1000, h: 668 },
	{ path: '48266322_2309072469167931_9034079054159937536_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48266322_2309072469167931_9034079054159937536_o.jpg', w: 1000, h: 668 },
	{ path: '48268862_2308768002531711_1174871759606775808_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48268862_2308768002531711_1174871759606775808_o.jpg', w: 1000, h: 668 },
	{ path: '48269394_2308808272527684_4934577583816704000_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48269394_2308808272527684_4934577583816704000_o.jpg', w: 1000, h: 668 },
	{ path: '48270258_2308764692532042_1183490217076588544_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48270258_2308764692532042_1183490217076588544_o.jpg', w: 1000, h: 668 },
	{ path: '48270454_2308760545865790_4849278090209132544_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48270454_2308760545865790_4849278090209132544_o.jpg', w: 1000, h: 668 },
	{ path: '48270511_2308807069194471_2510349977251741696_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48270511_2308807069194471_2510349977251741696_o.jpg', w: 1000, h: 668 },
	{ path: '48270850_2309074055834439_6280257087524044800_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48270850_2309074055834439_6280257087524044800_o.jpg', w: 1000, h: 668 },
	{ path: '48274918_2308804682528043_4252939112568324096_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48274918_2308804682528043_4252939112568324096_o.jpg', w: 1000, h: 668 },
	{ path: '48275343_2308759735865871_6843666258848645120_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48275343_2308759735865871_6843666258848645120_o.jpg', w: 1000, h: 668 },
	{ path: '48275554_2308778865863958_5747631613257187328_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48275554_2308778865863958_5747631613257187328_o.jpg', w: 1000, h: 668 },
	{ path: '48277541_2309073455834499_7378107013928058880_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48277541_2309073455834499_7378107013928058880_o.jpg', w: 1000, h: 668 },
	{ path: '48278050_2308765242531987_199591201874116608_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48278050_2308765242531987_199591201874116608_o.jpg', w: 1000, h: 668 },
	{ path: '48281605_2308805115861333_3269498842822737920_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48281605_2308805115861333_3269498842822737920_o.jpg', w: 1000, h: 668 },
	{ path: '48281738_2308769962531515_8667274304322273280_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48281738_2308769962531515_8667274304322273280_o.jpg', w: 1000, h: 668 },
	{ path: '48315842_2309076032500908_2331309699967746048_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48315842_2309076032500908_2331309699967746048_o.jpg', w: 1000, h: 668 },
	{ path: '48356655_2308772752531236_8968967607650615296_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48356655_2308772752531236_8968967607650615296_o.jpg', w: 1000, h: 668 },
	{ path: '48357202_2308767452531766_7742721639682408448_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48357202_2308767452531766_7742721639682408448_o.jpg', w: 1000, h: 668 },
	{ path: '48357658_2308812849193893_6356078193899732992_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48357658_2308812849193893_6356078193899732992_o.jpg', w: 1000, h: 668 },
	{ path: '48359615_2309076445834200_1357674432537034752_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48359615_2309076445834200_1357674432537034752_o.jpg', w: 1000, h: 668 },
	{ path: '48360191_2308772262531285_6949561757023076352_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48360191_2308772262531285_6949561757023076352_o.jpg', w: 1000, h: 668 },
	{ path: '48360485_2308813862527125_6094215652770316288_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48360485_2308813862527125_6094215652770316288_o.jpg', w: 1000, h: 668 },
	{ path: '48360582_2308774105864434_8940439193625034752_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48360582_2308774105864434_8940439193625034752_o.jpg', w: 1000, h: 668 },
	{ path: '48360945_2309075565834288_3009476793963905024_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48360945_2309075565834288_3009476793963905024_o.jpg', w: 1000, h: 668 },
	{ path: '48361065_2308770449198133_6792481595983921152_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48361065_2308770449198133_6792481595983921152_o.jpg', w: 1000, h: 668 },
	{ path: '48361587_2308813375860507_5458749501588111360_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48361587_2308813375860507_5458749501588111360_o.jpg', w: 1000, h: 668 },
	{ path: '48362616_2308762485865596_1785316655388164096_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48362616_2308762485865596_1785316655388164096_o.jpg', w: 1000, h: 668 },
	{ path: '48362815_2309078819167296_3794263500440731648_o-thumb.jpg', w: 668, h: 1000 },
	{ path: '48362815_2309078819167296_3794263500440731648_o.jpg', w: 668, h: 1000 },
	{ path: '48363862_2308809189194259_7494159371023155200_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48363862_2308809189194259_7494159371023155200_o.jpg', w: 1000, h: 668 },
	{ path: '48364307_2308751312533380_6035712958338695168_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48364307_2308751312533380_6035712958338695168_o.jpg', w: 1000, h: 668 },
	{ path: '48364687_2308766225865222_413861459504660480_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48364687_2308766225865222_413861459504660480_o.jpg', w: 1000, h: 668 },
	{ path: '48364710_2308815565860288_4860445331596247040_o-thumb.jpg', w: 668, h: 1000 },
	{ path: '48364710_2308815565860288_4860445331596247040_o.jpg', w: 668, h: 1000 },
	{ path: '48364925_2308776002530911_5757127824603348992_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48364925_2308776002530911_5757127824603348992_o.jpg', w: 1000, h: 668 },
	{ path: '48365000_2308806602527851_5620976042765189120_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48365000_2308806602527851_5620976042765189120_o.jpg', w: 1000, h: 668 },
	{ path: '48365716_2308758435866001_5691333942150430720_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48365716_2308758435866001_5691333942150430720_o.jpg', w: 1000, h: 668 },
	{ path: '48366762_2308808749194303_5125859295283380224_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48366762_2308808749194303_5125859295283380224_o.jpg', w: 1000, h: 668 },
	{ path: '48369030_2308812369193941_9203383804520038400_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48369030_2308812369193941_9203383804520038400_o.jpg', w: 1000, h: 668 },
	{ path: '48369067_2308757699199408_5113240634123091968_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48369067_2308757699199408_5113240634123091968_o.jpg', w: 1000, h: 668 },
	{ path: '48369769_2308753805866464_4848505786369835008_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48369769_2308753805866464_4848505786369835008_o.jpg', w: 1000, h: 668 },
	{ path: '48370719_2308777415864103_501127962234454016_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48370719_2308777415864103_501127962234454016_o.jpg', w: 1000, h: 668 },
	{ path: '48372551_2309078395834005_7750254153326133248_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48372551_2309078395834005_7750254153326133248_o.jpg', w: 1000, h: 668 },
	{ path: '48373067_2308756579199520_5082708441760268288_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48373067_2308756579199520_5082708441760268288_o.jpg', w: 1000, h: 668 },
	{ path: '48373703_2308770972531414_4059307693213483008_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48373703_2308770972531414_4059307693213483008_o.jpg', w: 1000, h: 668 },
	{ path: '48375974_2308815019193676_7513844821048426496_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48375974_2308815019193676_7513844821048426496_o.jpg', w: 1000, h: 668 },
	{ path: '48376010_2308761889198989_5440093885936173056_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48376010_2308761889198989_5440093885936173056_o.jpg', w: 1000, h: 668 },
	{ path: '48376831_2309076809167497_4627894829865500672_o-thumb.jpg', w: 668, h: 1000 },
	{ path: '48376831_2309076809167497_4627894829865500672_o.jpg', w: 668, h: 1000 },
	{ path: '48377052_2308757185866126_3204192847179808768_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48377052_2308757185866126_3204192847179808768_o.jpg', w: 1000, h: 668 },
	{ path: '48380610_2308773335864511_814816181507588096_o-thumb.jpg', w: 668, h: 1000 },
	{ path: '48380610_2308773335864511_814816181507588096_o.jpg', w: 668, h: 1000 },
	{ path: '48382669_2308753255866519_5967071529748398080_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48382669_2308753255866519_5967071529748398080_o.jpg', w: 1000, h: 668 },
	{ path: '48383381_2308761149199063_2723174480170975232_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48383381_2308761149199063_2723174480170975232_o.jpg', w: 1000, h: 668 },
	{ path: '48383570_2308751795866665_4291451504490971136_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48383570_2308751795866665_4291451504490971136_o.jpg', w: 1000, h: 668 },
	{ path: '48384989_2308810859194092_7248276848423993344_o-thumb.jpg', w: 1650, h: 942 },
	{ path: '48384989_2308810859194092_7248276848423993344_o.jpg', w: 1650, h: 942 },
	{ path: '48385002_2308758069199371_248805449707552768_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48385002_2308758069199371_248805449707552768_o.jpg', w: 1000, h: 668 },
	{ path: '48385414_2308769142531597_7190049336841994240_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48385414_2308769142531597_7190049336841994240_o.jpg', w: 1000, h: 668 },
	{ path: '48386135_2308811242527387_5827247580936929280_o-thumb.jpg', w: 2016, h: 1134 },
	{ path: '48386135_2308811242527387_5827247580936929280_o.jpg', w: 2016, h: 1134 },
	{ path: '48386886_2309075045834340_1655160222693457920_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48386886_2309075045834340_1655160222693457920_o.jpg', w: 1000, h: 668 },
	{ path: '48388822_2308778359197342_8401191244859965440_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48388822_2308778359197342_8401191244859965440_o.jpg', w: 1000, h: 668 },
	{ path: '48389784_2308754505866394_6760367416842125312_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48389784_2308754505866394_6760367416842125312_o.jpg', w: 1000, h: 668 },
	{ path: '48389870_2309072909167887_6342806384177840128_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48389870_2309072909167887_6342806384177840128_o.jpg', w: 1000, h: 668 },
	{ path: '48390309_2309077282500783_6729896389108563968_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48390309_2309077282500783_6729896389108563968_o.jpg', w: 1000, h: 668 },
	{ path: '48390697_2309071852501326_1949408359127973888_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48390697_2309071852501326_1949408359127973888_o.jpg', w: 1000, h: 668 },
	{ path: '48391029_2308811799193998_2140456703546621952_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48391029_2308811799193998_2140456703546621952_o.jpg', w: 1000, h: 668 },
	{ path: '48392413_2308759145865930_7411442793437986816_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48392413_2308759145865930_7411442793437986816_o.jpg', w: 1000, h: 668 },
	{ path: '48393424_2308765832531928_5445765643653611520_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48393424_2308765832531928_5445765643653611520_o.jpg', w: 1000, h: 668 },
	{ path: '48393535_2308764202532091_3487547829860171776_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48393535_2308764202532091_3487547829860171776_o.jpg', w: 1000, h: 668 },
	{ path: '48397043_2309077622500749_4886052738363817984_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48397043_2309077622500749_4886052738363817984_o.jpg', w: 1000, h: 668 },
	{ path: '48397882_2309074662501045_6103162877101735936_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48397882_2309074662501045_6103162877101735936_o.jpg', w: 1000, h: 668 },
	{ path: '48405682_2308752942533217_8171367720944664576_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48405682_2308752942533217_8171367720944664576_o.jpg', w: 1000, h: 668 },
	{ path: '48406249_2308775195864325_9088966296661393408_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48406249_2308775195864325_9088966296661393408_o.jpg', w: 1000, h: 668 },
	{ path: '48415362_2308755952532916_2614024457643098112_o-thumb.jpg', w: 807, h: 1193 },
	{ path: '48415362_2308755952532916_2614024457643098112_o.jpg', w: 807, h: 1193 },
	{ path: '48416563_2308807562527755_5800086469750030336_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48416563_2308807562527755_5800086469750030336_o.jpg', w: 1000, h: 668 },
	{ path: '48419303_2308814489193729_3627601842889818112_o-thumb.jpg', w: 668, h: 1000 },
	{ path: '48419303_2308814489193729_3627601842889818112_o.jpg', w: 668, h: 1000 },
	{ path: '48421404_2308810415860803_7379775509938307072_o-thumb.jpg', w: 2016, h: 1134 },
	{ path: '48421404_2308810415860803_7379775509938307072_o.jpg', w: 2016, h: 1134 },
	{ path: '48425271_2308816195860225_8242846241721942016_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '48425271_2308816195860225_8242846241721942016_o.jpg', w: 1000, h: 668 },
]

const newArray = Holiday2018Array.sort((a, b) => {
	if (a.path < b.path) return -1
	if (a.path > b.path) return 1
	return 0
})

//TODO: To improve this group thumb and full and make a nice full object.

export default () => {
	const componentArray = []
	for (let i = 0; i < newArray.length; i++) {
		componentArray.push(
			<figure
				itemProp="associatedMedia"
				itemScope="itemScope"
				itemType="http://schema.org/ImageObject"
				key={newArray[i].path}
			>
				<a
					href={Holiday2018[newArray[i + 1].path]}
					itemProp="contentUrl"
					data-size={`${newArray[i + 1].w}x${newArray[i + 1].h}`}
				>
					<img
						src={Holiday2018[newArray[i].path]}
						itemProp="thumbnail"
						alt="description"
					/>
				</a>
				<figcaption itemProp="caption description">{newArray[i + 1].caption}</figcaption>
			</figure>
		)
		i++
	}
	return componentArray
}
